export enum ActionDocumentType {
    DocumentWithFeedback,
    Readonly,
    ForSign,
    Downloadable,
    IdNda,
    Miscellaneous,
}

export const DocumentDetailsTypesOptions = {
    [ActionDocumentType.DocumentWithFeedback]: 'Needs feedback / confirmation',
    [ActionDocumentType.Readonly]: 'Read-Only PDF, non-downloadable',
    [ActionDocumentType.ForSign]: 'Needs to be signed',
    [ActionDocumentType.Downloadable]: 'Downloadable PDF',
    [ActionDocumentType.IdNda]: 'ID NDA',
    [ActionDocumentType.Miscellaneous]: 'Miscellaneous',
};

export const EngagementDocumentTypeOptionsMapping = [
    {
        value: ActionDocumentType.DocumentWithFeedback,
        label: DocumentDetailsTypesOptions[
            ActionDocumentType.DocumentWithFeedback
        ],
        fileExtensions:
            '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.pdf',
    },
    {
        value: ActionDocumentType.Readonly,
        label: DocumentDetailsTypesOptions[ActionDocumentType.Readonly],
        fileExtensions: '.pdf',
    },
    {
        value: ActionDocumentType.ForSign,
        label: DocumentDetailsTypesOptions[ActionDocumentType.ForSign],
    },
    {
        value: ActionDocumentType.Downloadable,
        label: DocumentDetailsTypesOptions[ActionDocumentType.Downloadable],
        fileExtensions: '.pdf',
    },
];

export const DocumentExecutionTypeOptionsMapping = [
    {
        value: ActionDocumentType.Miscellaneous,
        label: DocumentDetailsTypesOptions[ActionDocumentType.Miscellaneous],
    },
];
